module.exports = __webpack_public_path__ + "img/tooltip-information-sans-serif.bfa2d07.svg";